import { v4 as uuidv4 } from 'uuid';
import { AveMessageType } from '../model/index.js';
export function generateRequest({ messageId, name, data = {} }) {
    return generateAveMessage({ name, data, type: AveMessageType.REQUEST, messageId });
}
export function generateUpdate({ messageId, name, data = {}, referenceMessageId }) {
    return generateAveMessage({ name, data, type: AveMessageType.UPDATE, messageId, referenceMessageId });
}
export function generateError({ messageId, name, data = {}, referenceMessageId }) {
    return generateAveMessage({ name, data, type: AveMessageType.ERROR, messageId, referenceMessageId });
}
function generateAveMessage({ name, data = {}, type, messageId = uuidv4(), referenceMessageId }) {
    return {
        meta: {
            name,
            type,
            messageId,
            referenceMessageId,
            /**
             * - true: You get a response as soon as the Request is completely processed.
             * - false: You get an immediate but empty response.
             */
            lastUpdate: true
        },
        data
    };
}
//# sourceMappingURL=request.js.map